import $ from "jquery";
import { startResendTimer } from '../utils/utils-timer.js';
import { bindOtpInputs } from '../utils/utils-otp.js';
import { setButtonLoading, resetButtonLoading } from '../utils/utils-loading.js';

const login = () => {

	const el = {
		loginPage: '#login-page',
		stepLogin: '#step-login',
		stepOtp: '#step-otp',
		formLogin: '#form-login',
		formOtp: '#form-otp',
		btnBack: '#btn-back',
		btnResend: '#btn-resend',
		resendTimer: '#resend-timer',
		username: '#username',
		password: '#password',
		errUser: '#error-username',
		errPass: '#error-password',
		errOtp: '#error-otp',
		otpDigits: '.mi-login__otp-digit',
		loginStep: '.mi-login__step',
		otpEmail: '#otp-email',
	};

	let _user_id = null;

	if (!$(el.loginPage).length) return;

	const init = () => {
		bindLogin();
		bindOtp();
		bindBack();
		bindOtpInputs(el.otpDigits, 5);
		bindResend();
	};

	const showStep = (stepSelector) => {
		$(el.loginStep).removeClass('mi-login__step--active');
		$(stepSelector).addClass('mi-login__step--active');
	};

	const validateLogin = () => {
		let valid = true;

		$(el.username).removeClass('is-error');
		$(el.password).removeClass('is-error');
		$(el.errUser).text('').removeClass('is-visible');
		$(el.errPass).text('').removeClass('is-visible');

		if (!$(el.username).val().trim()) {
			$(el.errUser).text('Bitte Benutzernamen eingeben.').addClass('is-visible');
			$(el.username).addClass('is-error');
			valid = false;
		}
		if (!$(el.password).val().trim()) {
			$(el.errPass).text('Bitte Passwort eingeben.').addClass('is-visible');
			$(el.password).addClass('is-error');
			valid = false;
		}
		return valid;
	};

	const validateOtp = () => {
		$(el.errOtp).text('').removeClass('is-visible');
		const otp = $(el.otpDigits).map(function () { return $(this).val(); }).get().join('');
		if (otp.length < 5) {
			$(el.errOtp).text('Bitte vollständigen Code eingeben.').addClass('is-visible');
			return false;
		}
		return true;
	};

	const bindLogin = () => {
		$(el.formLogin).on('submit', (e) => {
			e.preventDefault();
			if (!validateLogin()) return;

			const $btn = $(el.formLogin).find('[type="submit"]');
			setButtonLoading($btn);

			$.ajax({
				// eslint-disable-next-line no-undef
				url: themeObj.ajaxUrl,
				type: 'POST',
				data: {
					// eslint-disable-next-line no-undef
					...themeObj.ajax.mi_login,
					username: $(el.username).val(),
					password: $(el.password).val(),
					remember: $('#remember').is(':checked') ? 1 : 0,
				},
			})
				.done((res) => {
					resetButtonLoading($btn);
					if (!res.success) {
						$(el.errUser).text(res.data.message).addClass('is-visible');
						return;
					}

					// Skip OTP role → redirect directly
					if (res.data.skip_otp) {
						window.location.href = res.data.redirect_url;
						return;
					}

					// Proceed to the OTP step
					_user_id = res.data.user_id;
					$(el.otpEmail).text(res.data.email);
					showStep(el.stepOtp);
					// eslint-disable-next-line no-undef
					startResendTimer(el.btnResend, el.resendTimer, themeObj.otp_resend_timer);
					$(el.otpDigits).first().focus();
				})
				.fail(() => {
					$(el.errUser).text('Ein Fehler ist aufgetreten.').addClass('is-visible');
				});
		});
	};

	const bindOtp = () => {
		$(el.formOtp).on('submit', (e) => {
			e.preventDefault();
			if (!validateOtp()) return;

			const otp = $(el.otpDigits).map(function () { return $(this).val(); }).get().join('');
			const $btn = $(el.formOtp).find('[type="submit"]');
			setButtonLoading($btn);

			$.ajax({
				// eslint-disable-next-line no-undef
				url: themeObj.ajaxUrl,
				type: 'POST',
				data: {
					// eslint-disable-next-line no-undef
					...themeObj.ajax.mi_verify_otp,
					otp: otp,
					user_id: _user_id,
				},
			})
				.done((res) => {
					resetButtonLoading($btn);
					if (!res.success) {
						$(el.errOtp).text(res.data.message).addClass('is-visible');
						return;
					}

					window.location.href = res.data.redirect_url;
				})
				.fail(() => {
					$(el.errOtp).text('Ein Fehler ist aufgetreten.').addClass('is-visible');
				});
		});
	};



	const bindBack = () => {
		$(el.btnBack).on('click', () => {
			showStep(el.stepLogin);
		});
	};

	const bindResend = () => {
		$(el.btnResend).on('click', () => {
			if (!_user_id) return;

			const $btn = $(el.btnResend).find('[type="submit"]');
			setButtonLoading($btn);

			$.ajax({
				// eslint-disable-next-line no-undef
				url: themeObj.ajaxUrl,
				type: 'POST',
				data: {
					// eslint-disable-next-line no-undef
					...themeObj.ajax.mi_resend_otp,
					user_id: _user_id,
				},
			})
				.done((res) => {
					resetButtonLoading($btn);
					if (!res.success) return;
					// eslint-disable-next-line no-undef
					startResendTimer(el.btnResend, el.resendTimer, themeObj.otp_resend_timer);
				})
				.fail(() => {
					console.error('Resend OTP failed');
				});
		});
	};

	init();
};

try {
	login();
} catch (error) {
	console.error('login', error);
}